import React from "react";
import { Link } from "react-router-dom";
import TypeIt from "typeit-react";

class Hero extends React.Component {
	render() {
		return (
			<div className={this.props.bg}>
				<div className={`hero row-container ${this.props.secondaryBg}`}>
					<div className="hero__content">
						<h1 className="hero__content__h1">{this.props.header}</h1>

						<h2 className="hero__content__h2">
							{/* {this.props.subHeader} */}
							<TypeIt
								options={{ loop: true }}
								getBeforeInit={(instance) => {
									instance
										.type("Fullstack Javascript Developer")
										.pause(750)
										.pause(1000)
										.delete()
										.type("React Native Developer")
										.pause(750)
										.pause(1000)
										.delete()
										.type("Mern Stack Developer")
										.pause(750)
										.pause(1000)
										.delete()
										.type("Mean Stack Developer")
										.pause(750)
										.pause(1000)
										.delete()
										.type("Python/Django Developer");

									// Remember to return it!
									return instance;
								}}
							/>
						</h2>

						{this.props.btnPara && (
							<Link to={`/contact`} className="hero__content__button">
								{this.props.btnPara}
							</Link>
						)}
					</div>
				</div>
			</div>
		);
	}
}

export default Hero;
